export default __webpack_public_path__ + "static/media/admin.8e7724eb.svg";